import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';
import { AutomatedTest, SubTestDependentTest, AutomatedTestStepQuickView, AutomatedTestParameter } from '../models/ast-element.model';


@AutoUnsubscribe()
@Component({
    selector: 'ASTQuickView',
    templateUrl: './quickview.component.html',
    styleUrls: ['./quickview.component.css']
})

export class QuickViewModalComponent implements OnDestroy, OnInit {

    PageTitle: string;
    Message: string;
    Test: AutomatedTest;
    dependentTests: SubTestDependentTest[] = [];
    ActionToTake: string;
    viewDependentTests = false;
    showTestSteps = false;
    testSteps: AutomatedTestStepQuickView[] = [];
    parameters: AutomatedTestParameter[] = [];

    constructor(
        private reportService: ReportingService,
        private dialogRef: MatDialogRef<QuickViewModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) {
        this.PageTitle = data.PageTitle;
        this.Message = data.Message;
        this.Test = data.Test;
        this.viewDependentTests = data.viewDependentTests;
        this.showTestSteps = data.showTestSteps;
    }

    ngOnInit() {

        if (this.viewDependentTests) {
            this.reportService.getSubTestDependentTests(this.Test.Test_ID).subscribe(dependentTests => {
                // console.log(dependentTests);
                this.dependentTests = dependentTests;
            });
        }

        if (this.showTestSteps) {
            this.reportService.getAutomatedTestQuickView(this.Test.Test_ID).subscribe(testSteps => {
               // console.log(testSteps);
               this.testSteps = testSteps;

               this.reportService.getAutomatedTestParameters(this.Test.Test_ID, 0).subscribe(res => {
                  // console.log(res);
                  this.parameters = res;

            });
        });
        }

    }

    ngOnDestroy() {
    }

    // showComments(comments: string) {
    //     console.log(comments);
    // }

    // okClick() {



    //     this.dialogRef.close(true);
    // }

    closeClick() {
        this.dialogRef.close();
    }


}